<template>
  <div
    tabindex="-1"
    role="dialog"
    class="modal-side-drawer-filters fade fixed-end op"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Advanced Search</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true"><i class="far fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" v-if="__initialized">
          <div class="data-filters">
            <div class="row mb-3">
              <div class="col-4 col-lg-4">
                <label>Search</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-search"></i>
                  </span>
                  <input type="text" class="form-control" :value="filters.search" @input="updateSearch"/>
                </div>
              </div>

              <div class="col-4 col-lg-4">
                <label>Client</label>

                <multiselect
                  :options="clients"
                  :show-labels="false"
                  :allow-empty="true"
                  placeholder
                  v-model="clientSelected"
                  label="company"
                />
              </div>

              <div class="col-4 col-lg-4">
                <label>Sort</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-sort-amount-down"></i>
                  </span>

                  <multiselect
                    :options="sortByOptions"
                    :show-labels="false"
                    :allow-empty="false"
                    placeholder
                    v-model="sortBy"
                    label="name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  mixins: [useQueryParamFilters()],

  data () {
    return {
      filters: {
        search: null,
        client: null,
        sort: 'updated,desc'
      },
      sortByOptions: [
        { name: 'Newest First', key: 'created', order: 'desc' },
        { name: 'Oldest First', key: 'created', order: 'asc' },
        { name: 'Last Updates', key: 'updated', order: 'desc' }
      ]
    }
  },

  computed: {
    ...mapState('clientsList', ['clients']),

    sortBy: {
      get () {
        const { filters, sortByOptions } = this

        return sortByOptions.find(({ order, key }) => filters.sort === `${key},${order}`)
      },

      set ({ key, order }) {
        this.filters.sort = `${key},${order}`
      }
    },

    clientSelected: {
      get () {
        return this.clients.find(({ id }) => id === parseInt(this.filters.client) )
      },

      set (value) {
        this.filters.client = value ? value.id : null
      }
    }
  },

  methods: {

    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750)
  },

  watch: {
    queryParams: {
      handler (params) {
        this.$emit('input', params)
      },
      immediate: true
    }
  }
}
</script>
